module.exports = __webpack_public_path__ + "img/840.787c961c.svg";